module.exports = __webpack_public_path__ + "static/media/uy.4bb9aa45.svg";